Vue.asyncComponent('cms-dashboard-queue-workers', {
    props: {
        statusLabel: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        statusTone: {
            type: String,
            default: 'success',
        },
        pendingJobCount: {
            type: Number,
            default: 0,
        },
        stalePendingJobCount: {
            type: Number,
            default: 0,
        },
        thresholdMinutes: {
            type: Number,
            default: 10,
        },
        jobs: {
            type: Array,
            default: () => [],
        },
        latestJob: {
            type: Object,
            default: null,
        },
    },
}, 'cms/dashboard/live/cms-dashboard-queue-workers.html');
